<template>
    <div>
        <BodycheckTaocantype />
    </div>
</template>

<script>
import BodycheckTaocantype from "./bodycheckTaocantypeView.vue";
export default {
    components: {
        BodycheckTaocantype,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
